import DeckTopSection from '../../../DeckBuilder/Decks/DeckTopSection'
import './CardFileBuilder.scss'
import { cardListTest, customCardDataTest, defaultCardDataTest } from './CardListTest'
import { useEffect, useState } from 'react'
import { Alert, Button, Col, Container, Form, Modal, Pagination, Row } from 'react-bootstrap'
import FocusedCardMenu from './FocusedCardMenu'
import { useGameContext } from '../../../Commons/GameContext'

export default function CardFileBuilder(props) {
    const [cardArray, setCardArray] = useState([])
    const [filteredCardArray, setFilteredCardArray] = useState([])
    const [displayedCardArray, setDisplayedCardArray] = useState([])
    const [focusedCard, setFocusedCard] = useState(false)
    const cardsPerPage = 30
    const [currentPage, setCurrentPage] = useState({
        current: 15,
        max: 28
    })
    const [searchQuery, setSearchQuery] = useState("")

    const [showCreateCardModal, setShowCreateCardModal] = useState(false)
    const [showEditCardDataModal, setShowEditCardDataModal] = useState(false)
    const [showDeleteCardModal, setShowDeleteCardModal] = useState(false)
    const [showImportModal, setShowImportModal] = useState(false)

    const [customCardData, setCustomCardData] = useState({
        cardTypes: [],
        customKeys: []
    })

    useEffect(() => {

    }, [])

    useEffect(() => {
        setDisplayedCardArray(filteredCardArray.slice((currentPage.current - 1) * cardsPerPage, currentPage.current * cardsPerPage))
    }, [currentPage])

    useEffect(() => {
        updateSearchByText(searchQuery)
    }, [searchQuery, cardArray.length])

    function updateSearchByText(query) {
        const searchQuery = query.toLowerCase()
        let tmpArray = []
        cardArray.forEach((c, i) => {
            if (query === "" || c.value.name.toLowerCase().includes(searchQuery) || c.key.toLowerCase().includes(searchQuery)) {
                tmpArray.push(c)
            }
        })
        setFilteredCardArray(tmpArray)
        setCurrentPage({
            current: 1,
            max: Math.ceil(tmpArray.length / cardsPerPage)
        })
    }

    function importCardData(data) {
        let JSONData = JSON.parse(JSON.stringify(data))
        let tmpArray = []
        Object.keys(JSONData).map((key, i) => {
            tmpArray.push({ key: key, value: JSONData[key], index: i })
        })
        setCardArray(tmpArray)
        if (tmpArray.length == 0) { return }
        setFocusedCard({ card: tmpArray[0] })   // ENELEVER .CARD ?
        console.log(tmpArray)

        let tmpData = {
            cardTypes: [],
            customKeys: []
        }
        tmpArray.forEach((c) => {
            // Type
            if (!tmpData.cardTypes.includes(c.value.type)) {
                tmpData.cardTypes.push(c.value.type)
            }
            if (c.value.face.front) {
                if (!tmpData.cardTypes.includes(c.value.face.front.type)) {
                    tmpData.cardTypes.push(c.value.face.front.type)
                }
            }
            if (c.value.face.back) {
                if (!tmpData.cardTypes.includes(c.value.face.back.type)) {
                    tmpData.cardTypes.push(c.value.face.back.type)
                }
            }

            // Keys
            Object.keys(c.value).map((key, i) => {
                if (!["face", "type", "cost", "id", "name", "isToken"].includes(key)) {
                    const keyIndex = tmpData.customKeys.findIndex((a) => a.title === key)
                    if (keyIndex === -1) {
                        let type = "Text"
                        if (Array.isArray(c.value[key])) {
                            type = "Text-Array"
                        } else if (typeof c.value[key] === 'number') {
                            type = 'Number';
                        } else if (typeof c.value[key] === 'boolean') {
                            type = 'Bool';
                        }
                        tmpData.customKeys.push({
                            title: key,
                            type: type
                        })
                    }
                }
            })
        })
        setCustomCardData(tmpData)
    }

    return (
        <>
            <DeckTopSection>
                <div className='d-flex justify-content-between position-relative'>
                    <h1>Card list</h1>
                    <div className='d-flex'>
                        <Button variant="secondary" className='mx-1 my-auto' onClick={() => setShowEditCardDataModal(true)}>Edit card data</Button>
                        <Button variant="secondary" className='mx-1 my-auto' onClick={() => setShowImportModal(true)}>Import existing card list</Button>
                        <Button variant="secondary" className='mx-1 my-auto' onClick={() => {
                            let data = {}
                            cardArray.forEach((c) => {
                                data[c.key] = c.value
                            })
                            const jsonStr = JSON.stringify(data, null, 2); // Pretty-print with 2 spaces
                            const blob = new Blob([jsonStr], { type: "application/json" });
                            const url = URL.createObjectURL(blob);

                            const a = document.createElement("a");
                            a.href = url;
                            a.download = "CardList";
                            a.click();

                            URL.revokeObjectURL(url); // Clean up
                        }}>Download</Button>
                    </div>
                    {props.returnButton}
                </div>
            </DeckTopSection>
            <div className="below-navbar">
                <Container className="p-5 pt-0 position-relative" style={{ minHeight: "85vh" }}>
                    <div className='d-flex flex-column text-start mx-auto card-file-builder'>
                        <Row>
                            <Col xs={4}>
                                <div className='d-flex flex-column'>
                                    <div className='d-flex flex-column card-list'>
                                        <Form.Control
                                            type="text"
                                            placeholder="Card name/id"
                                            defaultValue={searchQuery}
                                            onChange={(e) => {
                                                setSearchQuery(e.currentTarget.value)
                                            }}
                                        />
                                        <div className='d-flex justify-content-between align-items-center my-2'>
                                            <p className='m-0'>Results {currentPage.current * cardsPerPage - cardsPerPage + 1} to {Math.min(currentPage.current * cardsPerPage, filteredCardArray.length)} of {filteredCardArray.length}</p>
                                            <Button onClick={() => setShowCreateCardModal(true)}>Create card</Button>
                                        </div>
                                        {displayedCardArray.map((c, i) => {
                                            return (<Button
                                                key={i}
                                                className='card-button text-start'
                                                onClick={() => {
                                                    setFocusedCard(false)
                                                    setTimeout(() => {
                                                        setFocusedCard({ card: c })
                                                    }, 0)
                                                }}
                                            >
                                                <h5>{c.value.name}</h5>
                                                <p>{c.key}</p>
                                            </Button>)
                                        })}
                                        <div className=''>
                                            <CardListPagination />
                                        </div>
                                    </div>
                                </div>
                            </Col>

                            <Col xs={8}>
                                <div>
                                    {focusedCard && (<FocusedCardMenu
                                        focusedCard={focusedCard.card}
                                        key={focusedCard.card.index}
                                        applyChanges={(newValue) => {
                                            if (focusedCard) {
                                                let tmp = [...cardArray]
                                                tmp[focusedCard.card.index].value = newValue
                                                setCardArray(tmp)
                                            }
                                        }}
                                        updateCardId={(newId) => {
                                            if (focusedCard) {
                                                let tmp = [...cardArray]
                                                tmp[focusedCard.card.index].key = newId
                                                setCardArray(tmp)
                                            }
                                        }}
                                        showDeleteCardModal={() => setShowDeleteCardModal(true)}
                                        customCardData={customCardData}
                                    />)}
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Container>
            </div>
            <CreateCardModal
                show={showCreateCardModal}
                handleClose={() => setShowCreateCardModal(false)}
                cardArray={cardArray}
                createCard={(card) => {
                    let tmp = [...cardArray]
                    tmp.push({ key: card.id, value: { ...card }, index: tmp.length })
                    tmp.forEach((c, i) => {
                        c.index = i
                    })
                    setCardArray(tmp)
                    setFocusedCard({ card: tmp[tmp.length - 1] })
                }}
                customCardData={customCardData}
            />
            <EditCardDataModal
                show={showEditCardDataModal}
                handleClose={() => setShowEditCardDataModal(false)}
                customCardData={customCardData}
                setCustomCardData={setCustomCardData}
                updateTypeValue={(oldVal, newVal) => {
                    let tmp = [...cardArray]
                    tmp.forEach((c) => {
                        if (c.value.type === oldVal) {
                            c.value.type = newVal
                        }
                        if (c.value.face.front.type === oldVal) {
                            c.value.face.front.type = newVal
                        }
                        if (c.value.face.back && c.value.face.back.type === oldVal) {
                            c.value.face.back.type = newVal
                        }
                    })
                    setCardArray(tmp)
                }}
                updateKeyValue={(oldVal, newVal) => {
                    let tmp = [...cardArray]
                    tmp.forEach((c) => {
                        if (newVal === false) {
                            delete c.value[oldVal.title]
                        } else if (c.value[oldVal.title]) {
                            c.value[newVal.title] = c.value[oldVal.title]
                            delete c.value[oldVal.title]
                            if (oldVal.type !== "Text-Array" && newVal.type === "Text-Array") {
                                c.value[newVal.title] = [""]
                            }
                        }
                    })
                    setCardArray(tmp)
                }}
            />
            <DeleteCardModal
                show={showDeleteCardModal}
                handleClose={() => setShowDeleteCardModal(false)}
                deleteCard={() => {
                    let tmp = [...cardArray]
                    tmp.splice(focusedCard.card.index, 1)
                    tmp.forEach((c, i) => {
                        c.index = i
                    })
                    setCardArray(tmp)
                    setFocusedCard(false)
                }}
            />
            <ImportModal
                show={showImportModal}
                handleClose={() => setShowImportModal(false)}
                loadData={(data) => importCardData(data)}
            />
        </>
    )

    function CardListPagination() {
        function changePage(value) {
            if (value > 0 && value <= currentPage.max) {
                let tmp = { ...currentPage }
                tmp.current = value
                setCurrentPage(tmp)

                //setDisplayedCards(cardsResults.slice((value - 1) * cardsPerPage, value * cardsPerPage))
            }
        }

        function PaginationItem(props) {
            return (<Pagination.Item onClick={() => {
                changePage(props.value)
            }}>{props.value}</Pagination.Item>)
        }

        return (
            <Pagination className='d-flex justify-content-center my-3'>
                {currentPage.current > 3 && (<PaginationItem value={1} />)}
                {currentPage.current > 4 && (<div style={{ width: "1rem" }}></div>)}

                {currentPage.current - 2 > 0 && (<PaginationItem value={currentPage.current - 2} />)}
                {currentPage.current - 1 > 0 && (<PaginationItem value={currentPage.current - 1} />)}

                <Pagination.Item active>{currentPage.current}</Pagination.Item>

                {currentPage.current + 1 <= currentPage.max && (<PaginationItem value={currentPage.current + 1} />)}
                {currentPage.current + 2 <= currentPage.max && (<PaginationItem value={currentPage.current + 2} />)}

                {currentPage.current <= currentPage.max - 4 && (<div style={{ width: "1rem" }}></div>)}
                {currentPage.current <= currentPage.max - 3 && (<PaginationItem value={currentPage.max} />)}

            </Pagination>
        );
    }
}

function CreateCardModal(props) {
    const [errorMessage, setErrorMessage] = useState(false)
    const [newCard, setNewCard] = useState({ id: "", name: "" })

    return (
        <Modal className="" show={props.show} onHide={props.handleClose} centered onExited={() => {
            setNewCard({ id: "", name: "" })
            setErrorMessage(false)
        }}>
            <Modal.Header closeButton>
                <Modal.Title>Create card</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {errorMessage && (<Alert variant="danger">{errorMessage}</Alert>)}
                <p>The id must be unique</p>
                <p>The name doesn't have to be unique. Cards with the same name are groupped together in the deckbuilder as variants of the same card.</p>
                <div className='box-container d-flex align-items-center'>
                    <p className='text-nowrap m-0'>Card id</p>
                    <Form.Control
                        type="text"
                        placeholder="Id"
                        defaultValue={newCard.id}
                        onChange={(e) => {
                            let tmp = { ...newCard }
                            tmp.id = e.currentTarget.value
                            setNewCard(tmp)
                        }}
                    />
                </div>
                <div className='box-container d-flex align-items-center'>
                    <p className='text-nowrap m-0'>Card name</p>
                    <Form.Control
                        type="text"
                        placeholder="Name"
                        defaultValue={newCard.name}
                        onChange={(e) => {
                            let tmp = { ...newCard }
                            tmp.name = e.currentTarget.value
                            setNewCard(tmp)
                        }}
                    />
                </div>

            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => {
                    props.handleClose()
                }}>
                    Cancel
                </Button>
                <Button variant="primary" onClick={() => {
                    //props.deleteDeck()
                    let isIdAvailable = true
                    props.cardArray.forEach((c) => {
                        if (c.key === newCard.id) {
                            isIdAvailable = false
                        }
                    })
                    if (isIdAvailable) {
                        let cardData = {
                            "id": newCard.id,
                            "isToken": false,
                            "face": {
                                "front": {
                                    "name": "",
                                    "type": false,
                                    "cost": 0,
                                    "image": "",
                                    "isHorizontal": false
                                }
                            },
                            "name": newCard.name,
                            "type": false,
                            "cost": 0
                        }
                        props.customCardData.customKeys.forEach(k => {
                            let defaultValue = false
                            if (k.type === "Text") {
                                defaultValue = ""
                            } else if (k.type === "Number") {
                                defaultValue = 0
                            }
                            cardData[k.title] = defaultValue
                        })
                        console.log(cardData)
                        props.createCard(cardData)
                        props.handleClose()
                        setErrorMessage(false)
                    } else {
                        setErrorMessage("Id already used")
                    }
                }}>
                    Create
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

function EditCardDataModal(props) {
    return (
        <Modal className="fullscreen-modal" show={props.show} onHide={props.handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Edit card data</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <Col>
                        <div className='box-container d-flex flex-column'>
                            <h5>Card types</h5>
                            <p className='mb-5'>List of all card types that will be used by your cards.</p>
                            {props.customCardData.cardTypes.map((c, i) => {
                                return (<CardTypeLine
                                    key={i + "_" + c}
                                    type={c}
                                    applyChanges={(v) => {
                                        let tmp = { ...props.customCardData }
                                        tmp.cardTypes[i] = v
                                        props.setCustomCardData(tmp)
                                        props.updateTypeValue(c, v)
                                    }}
                                    deleteType={() => {
                                        let tmp = { ...props.customCardData }
                                        tmp.cardTypes.splice(i, 1)
                                        props.setCustomCardData(tmp)
                                        props.updateTypeValue(c, false)
                                    }}
                                />)
                            })}
                            <Button className='mt-5' onClick={() => {
                                let tmp = { ...props.customCardData }
                                tmp.cardTypes.push("")
                                props.setCustomCardData(tmp)
                            }}>Add type</Button>
                        </div>
                    </Col>

                    <Col>
                        <div className='box-container d-flex flex-column'>
                            <h5>Card properties</h5>
                            <p className='mb-5'>Card properties used in the deckbuilding section</p>
                            {props.customCardData.customKeys.map((k, i) => {
                                return (<CardKeyLine
                                    key={i + "_" + k.title}
                                    customKey={k}
                                    applyChanges={(v) => {
                                        let tmp = { ...props.customCardData }
                                        tmp.customKeys[i] = v
                                        props.setCustomCardData(tmp)
                                        props.updateKeyValue(k, v)
                                    }}
                                    deleteKey={() => {
                                        let tmp = { ...props.customCardData }
                                        tmp.customKeys.splice(i, 1)
                                        props.setCustomCardData(tmp)
                                        props.updateKeyValue(k, false)
                                    }}
                                />)
                            })}
                            <Button className='mt-5' onClick={() => {
                                let tmp = { ...props.customCardData }
                                tmp.customKeys.push({ title: "", type: "Text" })
                                props.setCustomCardData(tmp)
                            }}>Add key</Button>
                        </div>
                    </Col>
                </Row>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={() => {
                    props.handleClose()
                }}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    )

    function CardTypeLine(props) {
        const [isEditMode, setIsEditMode] = useState(false)
        const [value, setValue] = useState(props.type)

        return (
            <div className='d-flex align-items-center my-1'>
                {!isEditMode && (<div className='me-2'>
                    <Button variant="secondary" onClick={() => setIsEditMode(true)}>Edit</Button>
                </div>)}
                {isEditMode && (<div className=''>
                    <div className='d-flex'>
                        <Button className='' variant="secondary" onClick={() => setIsEditMode(false)}>Cancel</Button>
                        <Button className='mx-2' variant="primary" onClick={() => {
                            props.applyChanges(value)
                            setIsEditMode(false)
                        }}>Confirm</Button>
                    </div>
                </div>)}
                <Form.Control
                    type="text"
                    placeholder="Card type"
                    defaultValue={props.type}
                    className='w-100'
                    onChange={(e) => {
                        setValue(e.currentTarget.value)
                    }}
                    readOnly={!isEditMode}
                />
                {isEditMode && (<div className=''>
                    <div className='d-flex'>
                        <Button className="ms-2" variant="danger" onClick={() => {
                            props.deleteType()
                        }}>Delete</Button>
                    </div>
                </div>)}
            </div>
        )
    }

    function CardKeyLine(props) {
        const [isEditMode, setIsEditMode] = useState(false)
        const [value, setValue] = useState(props.customKey)

        return (
            <div className='d-flex my-1'>
                {!isEditMode && (<div className='me-2'>
                    <Button variant="secondary" onClick={() => setIsEditMode(true)}>Edit</Button>
                </div>)}
                {isEditMode && (<div className=''>
                    <div className='d-flex'>
                        <Button className='' variant="secondary" onClick={() => setIsEditMode(false)}>Cancel</Button>
                        <Button className='mx-2' variant="primary" onClick={() => {
                            props.applyChanges(value)
                            setIsEditMode(false)
                        }}>Confirm</Button>
                    </div>
                </div>)}
                <div className='d-flex w-100'>
                    <Form.Control
                        type="text"
                        placeholder="Title"
                        defaultValue={props.customKey.title}
                        onChange={(e) => {
                            let tmp = { ...value }
                            tmp.title = e.currentTarget.value
                            setValue(tmp)
                        }}
                        readOnly={!isEditMode}
                    />
                    <Form.Select
                        defaultValue={props.customKey.type}
                        className='ms-2'
                        onChange={(e) => {
                            let tmp = { ...value }
                            tmp.type = e.currentTarget.value
                            setValue(tmp)
                        }}
                        disabled={!isEditMode}
                    >
                        <option key="Text" value="Text">Text</option>
                        <option key="Text-Array" value="Text-Array">Text array</option>
                        <option key="Number" value="Number">Number</option>
                        <option key="Bool" value="Bool">Switch</option>
                    </Form.Select>
                </div>
                {isEditMode && (<div className=''>
                    <div className='d-flex'>
                        <Button className="ms-2" variant="danger" onClick={() => {
                            props.deleteKey()
                        }}>Delete</Button>
                    </div>
                </div>)}
            </div>
        )
    }
}

function DeleteCardModal(props) {
    return (
        <Modal className="" show={props.show} onHide={props.handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Delete card</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <p>This action cannot be undone.</p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={() => {
                    props.handleClose()
                }}>
                    Cancel
                </Button>
                <Button variant="danger" onClick={() => {
                    props.deleteCard()
                    props.handleClose()
                }}>
                    Delete card
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

function ImportModal(props) {
    const { gameCards, gameData } = useGameContext()

    const handleFileChange = (event) => {
        const file = event.target.files[0];

        // Check if a file is selected and is JSON
        if (file && file.type === "application/json") {
            const reader = new FileReader();

            reader.onload = (e) => {
                try {
                    const json = JSON.parse(e.target.result);
                    props.loadData({})
                    setTimeout(() => {
                        props.loadData(json)
                    }, 50)
                    props.handleClose()
                } catch (err) {
                    console.error("Error parsing JSON:", err);
                }
            };

            reader.readAsText(file);
        } else {
            alert("Please upload a valid .json file");
        }
    };

    return (
        <Modal className="" show={props.show} onHide={props.handleClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Import existing card list</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {gameData && (<div className='box-container d-flex flex-column'>
                    <h5>Load current game</h5>
                    <p className='mb-3'>Replace the card list and card data with the card list from the currently selected game.</p>
                    <Button onClick={() => {
                        props.loadData({})
                        setTimeout(() => {
                            props.loadData(gameCards)
                        }, 50)
                        props.handleClose()
                    }}>Load card list</Button>
                </div>)}

                <div className='box-container d-flex flex-column'>
                    <h5>Import file</h5>
                    <p className='mb-3'>Replace the card list and card data with the card list from a selected .JSON file.</p>
                    <div>
                        <Form.Control type="file" onChange={handleFileChange} />
                    </div>
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={() => {
                    props.handleClose()
                }}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    )
}